"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _style = require("./style");
var _Touchable = _interopRequireDefault(require("../Touchable"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function RadioButton(_ref) {
  var children = _ref.children,
    value = _ref.value,
    onClick = _ref.onClick,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Touchable["default"], {
    onPress: function onPress() {
      if (!disabled) onClick(value);
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.RadioWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.RadioCircle, {
        selected: selected,
        disabled: disabled,
        children: selected && /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.RadioCircleChild, {
          selected: selected,
          disabled: disabled
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.RadioText, {
        disabled: disabled,
        children: children
      })]
    })
  });
}
RadioButton.propTypes = {
  onClick: _propTypes.func.isRequired,
  children: _propTypes.string.isRequired,
  selected: _propTypes.bool,
  disabled: _propTypes.bool,
  value: _propTypes.string.isRequired
};
var _default = exports["default"] = RadioButton;